import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Formik, Field, Form, ErrorMessage } from "formik";
import { Container, Row, Col, Button, Card } from "react-bootstrap";
import loaderimage from "../../images/giphy.gif";
import axios from "axios";
import ConfirmationModal from "../shared/ConfirmationModal";
import NewconfirmationModal from "../shared/NewconfirmationModal";
import AllFailureModal from "../shared/AllFailureModal";
const _ = require("lodash");

const UpdateCategory = () => {
  const { categoryid } = useParams();

  const jobsInitialState = {
    category_id: categoryid,
    category_name: "",
    subcategory_id: "",
    category_icon: "",
    industry_id: "",
  };

  const [updateData, SetUpdateData] = useState(jobsInitialState);
  const [loader, setLoader] = useState(false);
  const navigate = useNavigate();
  // const [showNoChangeModal, setShowNoChangeModal] = useState(false);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [showFailureModal, setShowFailureModal] = useState(false);
  const [successMessage, setSuccessMessage] = useState(""); // /* Changed: New success message state */
  const [failureMessage, setFailureMessage] = useState(""); 
  const [currentFormValues, setCurrentFormValues] = useState(jobsInitialState);
  const [showDropdown, setShowDropdown] = useState(false);
  const [industries, setIndustries] = useState([]);
  const [filteredIndustries, setFilteredIndustries] = useState([]);
  const [selectedIndustryName, setSelectedIndustryName] = useState("");

    useEffect(() => {
      const fetchIndustries = async () => {
        try {
          const response = await axios.get(process.env.REACT_APP_API_URL + 'industries/get-all-industries');
          setIndustries(response.data);
          setFilteredIndustries(response.data); 
        } catch (error) {
          console.error('Error fetching industries:', error);
        }
      };
  
      fetchIndustries();
    }, []);
  
    const handleIndustrySearch = (e) => {
      const searchTerm = e.target.value.toLowerCase();
      const filtered = industries.filter((industry) =>
        industry.name.toLowerCase().includes(searchTerm)
      );
      setFilteredIndustries(filtered);
    };
    
    const handleIndustrySelect = (industry, setFieldValue) => {
      setFieldValue("industry_id", industry.id);
      setSelectedIndustryName(industry.name);  
      setShowDropdown(false);
    };

  const updateHandler = async (values) => {
    try {
      setLoader(true);
      const url = process.env.REACT_APP_API_URL + `category/edit/${categoryid}`;
      const response = await axios.put(url, values);
      setSuccessMessage("Category updated successfully!");
      setShowSuccessModal(true);
      setTimeout(() => {
        navigate("/categories");
      }, 3000);   

    } catch (error) {
      console.log(error);
      setFailureMessage("Error updating category. Please try again.");
      setShowFailureModal(true);
    } finally {
      setLoader(false);
    }
  };

  const validateForm = (values) => {
    let errors = {};

    const requiredFields = {
      category_id: "Category id required *",
      category_name: "Category name is required *",
      subcategory_id: "SubCategory id is required *",
      category_icon: "Category icon is required*" ,
    };

    for (const field in requiredFields) {
      if (!values[field]) {
        errors[field] = requiredFields[field];
      }
    }

    return errors;
  };

  const getCategoryByIDApi = async (categoryid) => {
    try {
      setLoader(true);
      const url =
        process.env.REACT_APP_API_URL +
        `category/getcategorybyid/${categoryid}`;
      const response = await axios.get(url);
      return response.data;
    } catch (error) {
      console.log(error);
    } finally {
      setLoader(false);
    }
  };

  useEffect(() => {
    (async () => {
      let data = await getCategoryByIDApi(categoryid);
      SetUpdateData(data);
      if (data && data.industry_id && industries.length > 0) {
        const industry = industries.find((ind) => ind.id === data.industry_id);
        if (industry) {
          setSelectedIndustryName(industry.name);
        }
      }
    })();
  }, [categoryid,industries]);

  return (
    <Container className="mt-5">
      <Row className="justify-content-center">
        <Col md={8}>
          <Card className="shadow">
            <Card.Header className="bg-info text-white text-center">
              <h4>Update Category</h4>
            </Card.Header>
            <Card.Body>
              <Formik
                enableReinitialize={true}
                initialValues={updateData}
                validate={validateForm}
                onSubmit={async (values) => {
                  // console.log(values);
                  if (_.isEqual(values, updateData)) {
                    setSuccessMessage("No changes made.");
                    setShowSuccessModal(true);
                  } else {
                    setShowConfirmationModal(true);
                    setCurrentFormValues(values);
                    }
                  
                }}
              >
                {({ setFieldValue, values }) => (
                  <Form>
                    <Row className="mb-3">
                      <Col md={12}>
                        <label htmlFor="industry_id" className="form-label">
                          Industry:
                        </label>
                        <div className="dropdown">
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Select Industry"
                            value={selectedIndustryName}
                            onChange={(e) => {
                              handleIndustrySearch(e);
                              setSelectedIndustryName(e.target.value); 
                              setShowDropdown(true);
                            }}
                          />
                          {showDropdown && (
                            <div className="dropdown-menu show" style={{ width: '100%' }}>
                              {filteredIndustries.map((industry) => (
                                <button
                                  key={industry.id}
                                  type="button"
                                  className="dropdown-item"
                                  onClick={() => handleIndustrySelect(industry, setFieldValue)}
                                >
                                  {industry.name}
                                </button>
                              ))}
                            </div>
                          )}
                        </div>
                        <ErrorMessage
                          name="industry_id"
                          component="div"
                          className="text-danger mt-1"
                        />
                      </Col>
                    </Row>
                                  
                    <Row className="mb-3">
                      <Col md={12}>
                        <label htmlFor="category_id" className="form-label">
                          Category ID:
                        </label>
                        <Field
                          name="category_id"
                          type="text"
                          className="form-control"
                          readOnly
                        />
                        <ErrorMessage
                          name="category_id"
                          component="div"
                          className="text-danger mt-1"
                          placeholder="Category Id"
                        />
                      </Col>
                    </Row>
                    
                    <Row className="mb-3">
                      <Col md={12}>
                        <label htmlFor="category_name" className="form-label">
                          Category Name:
                        </label>
                        <Field
                          name="category_name"
                          type="text"
                          className="form-control"
                          placeholder="Enter Category Name"
                        />
                        <ErrorMessage
                          name="category_name"
                          component="div"
                          className="text-danger mt-1"
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <Col md={12}>
                        <label htmlFor="subcategory_id" className="form-label">
                          SubCategory ID:
                        </label>
                        <Field
                          name="subcategory_id"
                          type="text"
                          className="form-control"
                          placeholder="Enter SubCategory ID"
                        />
                        <ErrorMessage
                          name="subcategory_id"
                          component="div"
                          className="text-danger mt-1"
                        />
                      </Col>
                    </Row>

                  <Row className="mb-3">
                      <Col md={12}>
                        <label htmlFor="category_icon" className="form-label">
                        Category Icon:
                        </label>
                        <Field
                          name="category_icon"
                          type="text"
                          className="form-control"
                          placeholder="Enter text"
                        />
                        <ErrorMessage
                          name="category_icon"
                          component="div"
                          className="text-danger mt-1"
                        />
                      </Col>
                    </Row>

                    <Row className="mt-4">
                      <Col className="text-center">
                        <Button type="submit" variant="success">
                          Update Category
                        </Button>
                        <Button
                          type="button"
                          variant="danger"
                          className="mx-2"
                          onClick={() => navigate("/categories")}
                        >
                          Go Back
                        </Button>
                      </Col>
                    </Row>
                  </Form>
                )}
              </Formik>
            </Card.Body>
          </Card>
        </Col>
      </Row>
      {loader && (
        <div className="loader">
          <img src={loaderimage} alt="Loader" />
        </div>
      )}
 

      {/* Are you sure? Modal */}
      <ConfirmationModal
        show={showConfirmationModal}
        onHide={() => setShowConfirmationModal(false)} // Close modal
        modalMessage="Are you sure you want to update this category?"
        operationType="Confirm"
        confirmation={async () => {
          await updateHandler(currentFormValues);
          setShowConfirmationModal(false);
        }}
      />

      {/* Changes Made / No Changes Success Modal using NewconfirmationModal */}
      <NewconfirmationModal
        show={showSuccessModal}
        onHide={() => setShowSuccessModal(false)}
        modalMessage={successMessage}
        operationType="OK"
        timeoutDuration={3000}
      />

      {/* Failure Modal */}
      <AllFailureModal
        show={showFailureModal}
        onHide={() => setShowFailureModal(false)}
        modalMessage={failureMessage}
        operationType="OK"
        timeoutDuration={3000}
      />
    </Container>
  );
};

export default UpdateCategory;